// extracted by mini-css-extract-plugin
export var displayNone = "_oc-6";
export var imgContainer = "_oc-2";
export var overflowHidden = "_oc-3";
export var productInfoCardButtonContainer = "_oc-5";
export var productTitleText = "_oc-4";
export var rightArrow = "_oc-1";
export var rightArrowContainer = "_oc-0";